export enum ReservationStatus {
  Cancelled = 'cancelled',
  Purchased = 'purchased',
  Expired = 'expired',
  Reserved = 'reserved',
  TemporarilyHeld = 'temporarilyHeld',
  Unknown = 'unknown',
  UnknownExpired = 'unknownExpired',
}
